import { Map } from 'immutable';

import {
  FETCH_GROUP_MEMBERS_SUCCESS,
} from 'data/GroupMembers/actions';
import {
  FETCH_STUDENT_SUCCESS,
} from './actions';
import Student from './model';

export default function student(state = new Map(), action) {
  let newState = state;
  let studentModel;
  switch (action.type) {
    case FETCH_GROUP_MEMBERS_SUCCESS:
      action.payload.forEach((member) => {
        if (! member.studentGeneralInfo) return;
        studentModel = Student.create(member.studentGeneralInfo);
        if (newState.has(studentModel.id)) return;
        newState = newState.set(studentModel.id, studentModel);
      });
      return newState;
    case FETCH_STUDENT_SUCCESS:
      studentModel = Student.create(action.payload);
      if (newState.has(studentModel.id)) return;
      return state.set(studentModel.id, studentModel);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./containers/Student/reducer.js